import { Fragment, useRef, useEffect } from 'react';
import { Box } from '@material-ui/core';

import { SText } from '@setvi/shared/components';
import { AIIcon } from '@setvi/shared/components/sicons';

import AIloader from 'componentsV2/ai/loader';

import { AskPdfProps, ConversationProps } from '../..';
import { AITextarea, Placeholder, Sources } from './components';
import {
  AIBox,
  ChatContent,
  Content,
  IconBox,
  Message,
  TextareaBox,
  UserBox
} from './styled';

interface ChatProps extends Partial<AskPdfProps> {
  conversation: ConversationProps[];
  questions: string[];
  loading: boolean;
  error?: string;

  onSubmit: (val: string) => void;
  onCitationClick: (pageNumber: number) => void;
}

const Chat = ({
  id,
  name,
  error,
  typeId,
  loading,
  questions,
  thumbnail,
  conversation,
  onSubmit,
  onCitationClick
}: ChatProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [conversation]);

  return (
    <>
      <Content
        style={{
          height: conversation?.length ? 'calc(100% - 100px)' : '100%'
        }}
        // @ts-ignore
        ref={contentRef}>
        {!conversation?.length ? (
          <Placeholder
            questions={questions}
            onClick={onSubmit}
            thumbnail={thumbnail}
            typeId={typeId}
            name={name}
            id={id}
          />
        ) : (
          <ChatContent>
            {conversation?.map(({ question, answer, sources }, index) => (
              // Keyed by position rather than a fresh uuid: answers stream
              // in token by token, and a new key each render would remount
              // every message on every token.
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={`${index}-${question}`}>
                <UserBox>
                  <Message>{question}</Message>
                </UserBox>

                <AIBox
                  style={{
                    alignItems:
                      loading && !answer?.trim() ? 'center' : 'flex-start'
                  }}>
                  <IconBox>
                    <AIIcon fontSize="small" />
                  </IconBox>
                  {loading && !answer?.trim() ? (
                    <AIloader />
                  ) : (
                    <Message
                      style={{
                        background: '#F0F0F4'
                      }}>
                      <Box dangerouslySetInnerHTML={{ __html: answer }} />
                      <Sources
                        sources={sources}
                        onCitationClick={onCitationClick}
                      />
                    </Message>
                  )}
                </AIBox>
              </Fragment>
            ))}

            {!!error && (
              <AIBox>
                <SText size="sm" fontColor="#D32F2F" title={error} />
              </AIBox>
            )}
          </ChatContent>
        )}
      </Content>

      {!!conversation?.length && (
        <TextareaBox>
          <AITextarea onSubmit={onSubmit} width="60%" />
        </TextareaBox>
      )}
    </>
  );
};

export default Chat;
